import React, { useRef, useState, useMemo } from "react";
import {
  useFloating,
  useInteractions,
  useHover,
  useFocus,
  offset,
  flip,
  shift,
  arrow,
  FloatingPortal
} from "@floating-ui/react";

const FloatingTooltipSticky = ({ delay = 300, children, content }) => {
  const [open, setOpen] = useState(false);
  const arrowRef = useRef(null);

  const { x, y, strategy, refs, context } = useFloating({
    open,
    onOpenChange: setOpen,
    middleware: [offset(10), flip(), shift(), arrow({ element: arrowRef })],
  });

  const { getReferenceProps, getFloatingProps } = useInteractions([
    useHover(context, {
      delay: {
        open: delay,
        close: 0,
      },
    }),
    useFocus(context),
  ]);

  const { x: arrowX, y: arrowY } = context.middlewareData.arrow || {};

  const staticSide = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right",
  };

  const arrowSide = useMemo(
    () => staticSide[context.placement.split("-")[0]] || "",
    [context.placement]
  );

  return (
    <>
      <div ref={refs.setReference} {...getReferenceProps()}>
        {children}
      </div>

      {open && (
        <FloatingPortal>
          <div
            ref={refs.setFloating}
            style={{
              position: strategy,
              left: x || 0,
              top: y || 0,
              background: "black",
              color: "white",
              fontFamily: "'Open Sans', sans-serif",
              fontSize: 12,
              padding: 8,
              borderRadius: "4px",
              zIndex: 9999,
              opacity: 0.9,
            }}
            {...getFloatingProps()}
          >
            {content}
            <div
              ref={arrowRef}
              style={{
                position: "absolute",
                width: "10px",
                height: "10px",
                background: "inherit",
                left: arrowX ? `${arrowX}px` : "",
                top: arrowY ? `${arrowY}px` : "",
                [arrowSide]: "-5px",
                transform: "rotate(45deg)",
              }}
            />
          </div>
        </FloatingPortal>
      )}
    </>
  );
};

export default FloatingTooltipSticky;